import Link from "next/link";
import type { ReactNode } from "react";

interface LinkifyTarget {
  phrase: string;
  href: string;
}

// Turns the first occurrence of `phrase` inside a plain-string FAQ answer into
// an inline link. Lets data files keep string answers (required by the JSON-LD
// schema and /api/md routes) while the rendered FAQ links the phrase.
export function linkifyPhrase(text: string, { phrase, href }: LinkifyTarget): ReactNode {
  const index = text.indexOf(phrase);
  if (index === -1) return text;

  return (
    <>
      {text.slice(0, index)}
      <Link
        href={href}
        className="text-foreground font-medium underline underline-offset-4 transition-opacity hover:opacity-80"
      >
        {phrase}
      </Link>
      {text.slice(index + phrase.length)}
    </>
  );
}

// Same as linkifyPhrase, but tries several mutually-exclusive targets and
// applies the first one whose phrase is present in the answer.
export function linkifyFirstMatch(text: string, targets: LinkifyTarget[]): ReactNode {
  const target = targets.find((t) => text.includes(t.phrase));
  return target ? linkifyPhrase(text, target) : text;
}
